module.exports = __webpack_public_path__ + "img/icon_wait_grey.34db3c8f.svg";